module.exports = __webpack_public_path__ + "media/assets/images/layout/bg_404-text-617e62af1d21568339c97e3118781322.png";